import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface SidebarItemProps {
  text: string;
  icon: React.ReactNode;
  path: string;
  isActive: boolean;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  text,
  icon,
  isActive,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        borderRadius: 1,
        mb: 0.5,
        mx: 1,
        color: isActive ? theme.palette.primary.main : 'inherit',
        bgcolor: isActive ? 'rgba(22, 163, 74, 0.12)' : 'transparent',
        borderLeft: isActive ? `3px solid ${theme.palette.primary.main}` : '3px solid transparent',
        '&:hover': {
          bgcolor: isActive ? 'rgba(22, 163, 74, 0.16)' : 'rgba(22, 163, 74, 0.08)',
        },
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 40,
          color: isActive ? theme.palette.primary.main : 'inherit',
        }}
      >
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={text}
        primaryTypographyProps={{
          fontWeight: isActive ? 600 : 500,
          fontSize: '0.9rem',
          color: 'inherit',
        }}
      />
    </ListItemButton>
  );
};

export default SidebarItem;
